module.exports = __webpack_public_path__ + "img/level_04_silver.b1cd1902.svg";